export const STATUSES = [
  ["new", "New", "bg-[#FDF3E3] text-[#8A5A14] border-[#E5A855]/60"],
  ["contacted", "Contacted", "bg-[#E8F0FB] text-[#1E4E8C] border-[#1E4E8C]/30"],
  ["enrolled", "Enrolled", "bg-[#E4F3EA] text-[#14633A] border-[#14633A]/30"],
];
const MAP = Object.fromEntries(STATUSES.map(([k, l, c]) => [k, { l, c }]));

export const StatusBadge = ({ status }) => {
  const s = MAP[status] || MAP.new;
  return <span className={`rounded-full border px-2.5 py-1 text-[11px] font-semibold ${s.c}`} data-testid="lead-status-badge">{s.l}</span>;
};

export const StatusPicker = ({ value, onChange, disabled }) => (
  <div className="grid grid-cols-3 gap-2" data-testid="lead-status-picker">
    {STATUSES.map(([k, l, c]) => (
      <button key={k} disabled={disabled} onClick={() => onChange(k)} data-testid={`lead-status-${k}`} aria-pressed={value === k}
        className={`rounded-xl border px-3 py-2.5 text-sm font-semibold transition-colors disabled:opacity-60 ${value === k ? c : "bg-white border-[#0B281E]/15 text-[#52635B] hover:border-[#C88A35]"}`}>
        {l}
      </button>
    ))}
  </div>
);
